import React, { useState } from 'react'

const Newsletter = () => {

  const [emailaddress, setEmailAddress] = useState('')
  const subscribeHandler = ()=> {
    // e.preventDefault()
    console.log(emailaddress)
  }
  return (
    <div className='font-outfit px-3 lg:px-0 h-full w-full lg:max-w-[600px] mx-auto'>

        <h1 className='font-semibold text-2xl'>Subscribe to Newsletter</h1>

        <div className='flex justify-between py-4'> 
            <input type="email" placeholder='email' value={emailaddress} onChange={(e) => {
                setEmailAddress(e.target.value);
              }} className='w-full text-black mx-2  px-6' />
            <button onClick={()=> {
              subscribeHandler()
            }} className='transition hover:scale-105 bg-brand_yellow px-6 py-1 text-black font-outfit font-semibold'>Subscribe</button>
        </div>
    </div>
  )
}

export default Newsletter